import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { nextStep } from '../../store/formSlice';
import { Button, Box, Text, VStack } from '@chakra-ui/react';
import StepHeader from './StepHeader';

const WhySophieWorksStep = () => {
    const dispatch = useDispatch();
    const { currentStep, totalSteps } = useSelector((state) => state.form);

    const handleContinue = () => {
        dispatch(nextStep());
    };

    return (
        <Box maxW="4xl" mx="auto" p={6} textAlign="center">
            <StepHeader
                title="Why Sophie Care Works"
                subtitle='"A Small Moment Can Make a Big Difference."'
            />

            <VStack spacing={6} mb={8}>
                <Box bg={{ md: "brand.50" }} p={6} borderRadius="lg" border={{ base: "1px solid", md: "none" }} borderColor={{ base: "brand.500", md: "none" }}>
                    <Text color="brand.500" fontSize="20px" fontWeight="semibold" m={0} lineHeight="160%">
                        42% of seniors report regular feelings of loneliness.
                    </Text>
                </Box>

                <Box bg={{ md: "brand.50" }} p={6} borderRadius="lg" border={{ base: "1px solid", md: "none" }} borderColor={{ base: "brand.500", md: "none" }}>
                    <Text color="brand.500" fontSize="20px" fontWeight="semibold" m={0}>
                        Daily conversations can reduce cognitive decline by up to 60%.
                    </Text>
                </Box>
            </VStack>

            <Text fontSize="18px" color="gray.700" mb={8}>
                Sophie Care is here to help your loved one feel more connected, supported, and engaged.
            </Text>

            <Button
                onClick={handleContinue}
                mt={4}
                px="30px"
            >
                Continue
            </Button>
        </Box>
    );
};

export default WhySophieWorksStep;
